import { useMemo, useState } from "react";
import Card from "./Card.jsx";
import { getHighLow } from "../../lib/lotto.js";

export default function Probability({ rows }) {
  const [weeks, setWeeks] = useState(45);
  const { ratio, avg } = useMemo(() => getHighLow(rows, weeks), [rows, weeks]);
  const max = Math.max(...ratio);

  return (
    <Card
      title="번호별 가중 확률값"
      subtitle={`최근 ${weeks}회 · 평균 ${avg}`}
      span={2}
    >
      <div className="controls" style={{ marginBottom: 8 }}>
        <label>
          기간(회차):&nbsp;
          <input
            type="number"
            min={4}
            max={300}
            value={weeks}
            onChange={(e) => setWeeks(Number(e.target.value))}
          />
        </label>
      </div>
      <div className="prob-grid">
        {ratio.map((v, i) => {
          const pct = (v / max) * 100;
          const high = v >= avg;
          return (
            <div key={i} className="prob-cell">
              <span className={`ball ball-${Math.min(5, Math.floor(i / 10) + 1)}`}>
                {i + 1}
              </span>
              <div className="prob-track">
                <div
                  className={"prob-fill" + (high ? " hi" : "")}
                  style={{ height: `${pct}%` }}
                />
              </div>
              <span className="prob-val">{v}</span>
            </div>
          );
        })}
      </div>
    </Card>
  );
}
